import {z} from 'zod';

export const customerInfoSchema = z.object({
    erpCountryName: z.string().nullable(),
    countryCode: z.string().nullable(),
    debtorNo: z.string(),
    address1: z.string().nullable(),
    email: z.string().nullable(),
    erpCity: z.string().nullable(),
    erpPostalCode: z.string().nullable(),
    address2: z.string().nullable(),
    name: z.string(),
});
